import * as Types from "./types";

export const getSortedElements: Types.GetSortedElements = (elements = []) =>
  elements.sort((prev, next) => prev.position - next.position);

export const getPrevSameParts: Types.GetPrevSameParts = (
  elementParts,
  index,
) => ({
  prevSameParts: elementParts.filter(
    (part, partIndex) =>
      elementParts[index].partTypeClass === part.partTypeClass &&
      partIndex < index,
  ),
});
